'use client';
import { SectionContainer } from '../component/SectionContainer';
import MessageInfo from '../_bs-components/MessageInfo';
import MessageInfoMobile from '../_bs-components/MessageInfoMobile';
import { MeetingMsgItem } from '../type';

export interface IMessageInfoProps {
  className?: string;
  list: MeetingMsgItem[];
}

export default function MeetingMessageSection({
  data,
  title,
}: {
  data: MeetingMsgItem[];
  title: string;
}) {
  return (
    <SectionContainer
      title={title}
      contentClassName="mobile:max-w-auto mobile:!px-0"
    >
      <MessageInfo className="mobile:hidden -ml-5" list={data}></MessageInfo>
      <MessageInfoMobile
        className="hidden mobile:block"
        list={data}
      ></MessageInfoMobile>
    </SectionContainer>
  );
}
